<script>
export default {
  name: "desintationsVue",
  data() {
    return {
      geojsonFeature: {
        type: "FeatureCollection",
        name: "destinations",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: [
          {
            type: "Feature",
            properties: {
              name: "BMW Museum",
              address: "Am Olympiapark 2",
              toilets: "yes",
              website: "www.bmw-welt.com/",
            },
            geometry: {
              type: "Point",
              coordinates: [11.558833586379913, 48.176632669449234, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Rewe",
              address: "Petuelring 92",
              toilets: "no",
              website: "-",
            },
            geometry: {
              type: "Point",
              coordinates: [11.57227237404717, 48.178377118134769, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "St. Mauritius Apotheke",
              address: "Rümannstraße 5",
              toilets: "no",
              website: "www.st-mauritius-apotheke-schwabing.de",
            },
            geometry: {
              type: "Point",
              coordinates: [11.574167622565632, 48.17574427363737, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Deutsche Post",
              address: "Rümannstraße 13",
              toilets: "no",
              website:
                "www.deutschepost.de/de/s/standorte.html?objectid=4113754&isFeedbackDeeplink=true&template=locationdetail",
            },
            geometry: {
              type: "Point",
              coordinates: [11.574532267604061, 48.175813155974168, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Stadtsparkasse",
              address: "Belgradstraße 162",
              toilets: "no",
              website: "-",
            },
            geometry: {
              type: "Point",
              coordinates: [11.57298474255907, 48.177047385391148, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Deutsche Bundesbank",
              address: "Leopoldstraße 234",
              toilets: "no",
              website:
                "www.bundesbank.de/de/bundesbank/hauptverwaltungen-filialen/by/filialen/filiale-muenchen-605466",
            },
            geometry: {
              type: "Point",
              coordinates: [11.585570255572243, 48.179128773066452, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Commerzbank",
              address: "Leopoldstraße 230",
              toilets: "no",
              website: "-",
            },
            geometry: {
              type: "Point",
              coordinates: [11.58555601278343, 48.178188569525055, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Petuelpark",
              address: "Klopstockstraße 10",
              toilets: "no",
              website: "www.muenchen.de/sehenswuerdigkeiten/petuelpark",
            },
            geometry: {
              type: "Point",
              coordinates: [11.578695904148733, 48.177884662092161, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Olympiapark",
              address: "Spiridon-Louis-Ring 21",
              toilets: "no",
              website: "www.olympiapark.de/de/home/",
            },
            geometry: {
              type: "Point",
              coordinates: [11.547778235773931, 48.178977415673394, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Luitpoldpark",
              address: "Brunnerstraße 2",
              toilets: "no",
              website: "www.muenchen.de/sehenswuerdigkeiten/luitpoldpark",
            },
            geometry: {
              type: "Point",
              coordinates: [11.568822926001184, 48.170607550590297, 0.0],
            },
          },
        ],
      },
    };
  },
};
</script>
